import styled from '@emotion/styled';
import { Alert } from '@mui/material';

export const TableauDashboardContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  #tableau-viz-container {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    &.visibility-hidden {
      // Using visibility: hidden because we want the viz to exist in the DOM so
      // that the dashboard can be loaded by Tableau while being hidden from
      // view
      visibility: hidden;
    }
  }
`;

export const StyledAlert = styled(Alert)`
  align-self: center;
  align-items: center;
  .error-text {
    font-size: 1em;
    font-weight: 600;
  }
  .error-details {
    font-size: 1em;
  }
`;
